import { render } from "./FreebieList.vue?vue&type=template&id=5d29380c"
import script from "./FreebieList.vue?vue&type=script&lang=js"
export * from "./FreebieList.vue?vue&type=script&lang=js"

import "./FreebieList.vue?vue&type=style&index=0&id=5d29380c&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__